var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "b-card",
        [
          _c(
            "b-row",
            { attrs: { "align-v": "end" } },
            [
              _c("b-col", { staticClass: "col-md-6" }, [
                _c("label", { attrs: { for: "" } }, [
                  _vm._v("Escolha o Arquivo para Importação")
                ]),
                _vm._v(" "),
                _c("input", {
                  staticClass: "form-control",
                  attrs: { type: "file" },
                  on: { change: _vm.changeFile }
                })
              ]),
              _vm._v(" "),
              _c("b-col", { staticClass: "col-md-3" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    staticStyle: { "margin-top": "1.6em" },
                    on: { click: _vm.sendFile }
                  },
                  [
                    _c("i", { staticClass: "fa fa-send" }),
                    _vm._v(" Processar Arquivo")
                  ]
                )
              ]),
              _vm._v(" "),
              _vm.pedidosComErros === 0
                ? _c("b-col", { staticClass: "col-md-3" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-larger btn-success",
                        attrs: { disabled: !_vm.pedidos.length },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.sendPedidos.apply(null, arguments)
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "fa fa-save" }),
                        _vm._v(" ENVIAR PEDIDOS ")
                      ]
                    )
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.pedidosComErros > 0
            ? _c("div", [
                _c("h2", { staticClass: "text-danger" }, [
                  _vm._v(
                    "Há " +
                      _vm._s(_vm.pedidosComErros) +
                      " pedido (s) com erros. Por favor, verifique e tente novamente.\n\t\t\t"
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.pedidos, function(pedido, i) {
            return _c("div", { key: i, staticClass: "row" }, [
              _c("div", { staticClass: "col-md-12" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "card" }, [
                    _c("div", { staticClass: "card-body" }, [
                      pedido.erros.length > 0
                        ? _c(
                            "div",
                            { staticClass: "row", attrs: { role: "alert" } },
                            [
                              _c("div", { staticClass: "col-md-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "alert alert-danger" },
                                  [
                                    _c("strong", [
                                      _vm._v("Erros encontrados:")
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      _vm._l(pedido.erros, function(erro, e) {
                                        return _c("li", { key: e }, [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                              _vm._s(erro) +
                                              "\n\t\t\t\t\t\t\t\t\t\t\t"
                                          )
                                        ])
                                      }),
                                      0
                                    )
                                  ]
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "row" }, [
                            _c("legend", [
                              _vm._v("Revendedora "),
                              _c("small", { staticClass: "text-primary" }, [
                                _vm._v(
                                  "(" +
                                    _vm._s(
                                      pedido.revendedoras_existe
                                        ? "Atualizar"
                                        : "Cadastrar"
                                    ) +
                                    "):"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-8" }, [
                              _c("strong", [_vm._v("Nome: ")]),
                              _vm._v(
                                " " +
                                  _vm._s(pedido.revendedora.nome) +
                                  "\n\t\t\t\t\t\t\t\t\t\t"
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-4" }, [
                              _c("strong", [_vm._v("CPF: ")]),
                              _vm._v(
                                " " +
                                  _vm._s(pedido.revendedora.cpf) +
                                  "\n\t\t\t\t\t\t\t\t\t\t"
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-4" }, [
                              _c("strong", [_vm._v("RG: ")]),
                              _vm._v(
                                " " +
                                  _vm._s(pedido.revendedora.rg) +
                                  "\n\t\t\t\t\t\t\t\t\t\t"
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-4" }, [
                              _c("strong", [_vm._v("Data Nasc: ")]),
                              _vm._v(
                                " " +
                                  _vm._s(pedido.revendedora.data_nasc) +
                                  "\n\t\t\t\t\t\t\t\t\t\t"
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-4" }, [
                              _c("strong", [_vm._v("Email: ")]),
                              _vm._v(
                                " " +
                                  _vm._s(pedido.revendedora.email) +
                                  "\n\t\t\t\t\t\t\t\t\t\t"
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "row" }, [
                            _c("legend", [_vm._v("Endereço:")]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-4" }, [
                              _c("strong", [_vm._v("CEP: ")]),
                              _vm._v(
                                " " +
                                  _vm._s(pedido.revendedora.cep) +
                                  "\n\t\t\t\t\t\t\t\t\t\t"
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-8" }, [
                              _c("strong", [_vm._v("Logradouro: ")]),
                              _vm._v(
                                " " +
                                  _vm._s(pedido.revendedora.logradouro) +
                                  "\n\t\t\t\t\t\t\t\t\t\t"
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-4" }, [
                              _c("strong", [_vm._v("Bairro: ")]),
                              _vm._v(
                                " " +
                                  _vm._s(pedido.revendedora.bairro) +
                                  "\n\t\t\t\t\t\t\t\t\t\t"
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-4" }, [
                              _c("strong", [_vm._v("Complemento: ")]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    pedido.revendedora.bairro.complemento
                                  ) +
                                  "\n\t\t\t\t\t\t\t\t\t\t"
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-4" }, [
                              _c("strong", [_vm._v("Cidade: ")]),
                              _vm._v(
                                " " +
                                  _vm._s(pedido.revendedora.nome_cidade) +
                                  "\n\t\t\t\t\t\t\t\t\t\t\t-\n\t\t\t\t\t\t\t\t\t\t\t" +
                                  _vm._s(pedido.revendedora.estado) +
                                  "\n\t\t\t\t\t\t\t\t\t\t"
                              )
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-12" }, [
                          _c("h3", [_vm._v("Itens do Pedido")]),
                          _vm._v(" "),
                          _c(
                            "table",
                            {
                              staticClass:
                                "table-hover table-striped table-bordered",
                              attrs: { width: "100%" }
                            },
                            [
                              _c("thead", [
                                _c("tr", { staticClass: "text-primary" }, [
                                  _c("th", { staticClass: "text-center" }, [
                                    _vm._v("Código")
                                  ]),
                                  _vm._v(" "),
                                  _c("th", [_vm._v("Produto")]),
                                  _vm._v(" "),
                                  _c("th", { staticClass: "text-center" }, [
                                    _vm._v("Quantidade")
                                  ]),
                                  _vm._v(" "),
                                  _c("th", { staticClass: "text-center" }, [
                                    _vm._v("Total")
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(pedido.itens, function(item, z) {
                                  return _c(
                                    "tr",
                                    {
                                      key: z,
                                      class: {
                                        "bg-primary": !_vm.existeProduto(
                                          item.codigo
                                        )
                                      }
                                    },
                                    [
                                      _c("td", { staticClass: "text-center" }, [
                                        _vm._v(_vm._s(item.codigo))
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(_vm.getProduto(item.codigo))
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", { staticClass: "text-center" }, [
                                        _vm._v(_vm._s(item.quantidade))
                                      ]),
                                      _vm._v(" "),
                                      _c("td", { staticClass: "text-center" }, [
                                        _vm._v(
                                          "R$ " +
                                            _vm._s(
                                              _vm.calcPreco(
                                                item.codigo,
                                                item.quantidade
                                              )
                                            ) +
                                            "\n\t\t\t\t\t\t\t\t\t\t\t\t"
                                        )
                                      ])
                                    ]
                                  )
                                }),
                                0
                              )
                            ]
                          )
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-57e73e09", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57e73e09","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/distribuidor_importar_pedidos/Main.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-57e73e09","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/distribuidor_importar_pedidos/Main.vue
// module chunks = 2